import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import AdminShell from "../../admin/AdminShell";
import app from "../../../firebase";
import { getRoleAuth } from "../../../auth/roleSession";

export default function ResetPassword({ email: initialEmail, onClose }) {
  const navigate = useNavigate();
  const { userId } = useParams();
  const [email, setEmail] = useState(initialEmail || '');
  const [sending, setSending] = useState(false);
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(!initialEmail && !!userId);
  const [error, setError] = useState('');

  const isPage = !onClose;

  useEffect(() => {
    const fetchUser = async () => {
      setLoading(true);
      try {
        const db = getFirestore(app);
        const ref = doc(db, 'users', userId);
        const snap = await getDoc(ref);
        if (snap.exists()) {
          setEmail(snap.data()?.email || '');
        } else {
          setError('User not found');
        }
      } catch (err) {
        console.error(err);
        setError(err?.message || 'Failed to load user email');
      } finally {
        setLoading(false);
      }
    };
    if (!initialEmail && userId) fetchUser();
  }, [initialEmail, userId]);

  const handleSend = async () => {
    setSending(true);
    setMsg('');
    setError('');
    try {
      const auth = getRoleAuth("System Administrator");
      if (!email) {
        setMsg('No email available for this user');
        return;
      }
      // Basic validation: must contain '@' and end with '.com'
      if (!email.includes('@') || !email.toLowerCase().endsWith('.com')) {
        setError('Email must contain "@" and end with ".com"');
        return;
      }
      await sendPasswordResetEmail(auth, email);
      setMsg('Password reset email sent');
    } catch (err) {
      console.error('sendPasswordResetEmail failed', err);
      setMsg('Failed to send reset email');
    } finally {
      setSending(false);
    }
  };

  const content = (
    <div style={{ width: isPage ? '100%' : 420, maxWidth: isPage ? 680 : '96%', background: '#fff', borderRadius: 10, padding: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ margin: 0, color: '#155c2b' }}>Reset Password</h3>
        {onClose ? (
          <button onClick={onClose} style={{ background: 'transparent', border: 'none', fontSize: 18, cursor: 'pointer' }}>✕</button>
        ) : (
          <button onClick={() => navigate('/admin/users')} style={{ background: '#fff', border: '1px solid #dfe7e3', color: '#155c2b', padding: '8px 12px', borderRadius: 8, cursor: 'pointer' }}>Back to Users</button>
        )}
      </div>
      <div style={{ marginTop: 16 }}>
        {loading && <div>Loading email...</div>}
        {error && <div style={{ color: 'crimson' }}>{error}</div>}
        {!loading && !error && (
          <>
            <div style={{ color: '#333', marginBottom: 12 }}>Send a password reset email to <strong>{email}</strong>.</div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
              {onClose && <button onClick={onClose} style={{ background: '#fff', border: '1px solid #ddd', padding: '10px 14px', borderRadius: 8 }}>Cancel</button>}
              <button onClick={handleSend} disabled={sending} style={{ background: '#155c2b', color: '#fff', border: 'none', padding: '10px 14px', borderRadius: 8, cursor: 'pointer' }}>{sending ? 'Sending...' : 'Send'}</button>
            </div>
            {msg && <div style={{ marginTop: 12, color: '#555' }}>{msg}</div>}
          </>
        )}
      </div>
    </div>
  );

  if (isPage) {
    return (
      <AdminShell title="Reset Password">
        <div style={{ maxWidth: 720, margin: '0 auto' }}>{content}</div>
      </AdminShell>
    );
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 }}>
      {content}
    </div>
  );
}
